import { useState } from "react";
import { Smartphone, Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const APP_URL = "https://ftccrm.com/m";

/** Dashboard entry point for installing the mobile companion app. */
export function GetMobileAppButton() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(APP_URL).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const steps = [
    <>Scan the code (or open <span className="font-semibold text-foreground">ftccrm.com/m</span>) in <span className="font-semibold text-foreground">Safari</span> on your iPhone</>,
    <>Sign in with your Microsoft account</>,
    <>Tap <span className="font-semibold text-foreground">Share</span> <span className="text-muted-foreground">(the square with the arrow)</span>, then <span className="font-semibold text-foreground">Add to Home Screen</span></>,
    <>Open <span className="font-semibold text-foreground">FTC CRM</span> from your home screen — search, Send CIM, and reminders, as a real app</>,
  ];

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="h-8 gap-1.5 text-xs"
        onClick={() => setOpen(true)}
        data-testid="get-mobile-app"
      >
        <Smartphone className="h-3.5 w-3.5" />
        Get the mobile app
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Smartphone className="h-4 w-4 text-[#b8963e]" />
              FTC CRM on your iPhone
            </DialogTitle>
          </DialogHeader>

          <div className="flex items-start gap-5">
            <div className="shrink-0 rounded-xl border bg-white p-2">
              <img src="/mobile-app-qr.png" alt="QR code for ftccrm.com/m" className="h-36 w-36" />
            </div>
            <ol className="min-w-0 flex-1 space-y-2.5 pt-1">
              {steps.map((s, i) => (
                <li key={i} className="flex gap-2.5 text-[13px] leading-snug text-muted-foreground">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#0d1b2a] text-[10px] font-bold text-[#c9a227]">
                    {i + 1}
                  </span>
                  <span>{s}</span>
                </li>
              ))}
            </ol>
          </div>

          <div className="flex items-center justify-between rounded-lg border bg-muted/40 px-3 py-2">
            <span className="font-mono text-xs text-muted-foreground">{APP_URL}</span>
            <Button variant="ghost" size="sm" className="h-7 gap-1 px-2 text-xs" onClick={copy}>
              {copied ? <Check className="h-3 w-3 text-green-600 dark:text-green-400" /> : <Copy className="h-3 w-3" />}
              {copied ? "Copied" : "Copy link"}
            </Button>
          </div>

          <p className="text-[11px] leading-relaxed text-muted-foreground">
            No App Store needed — it installs straight from Safari and updates automatically. Turn on reminder
            notifications from the app's <span className="font-semibold">More</span> tab.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
}
